import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import loadable from '@loadable/component';
import Icon from 'ls-common-client/dist/components/Icon';
import Animation from 'ls-common-client/dist/components/Animation';
import DialogForm from '../DialogForm';
import FullScreenLoader from '../FullScreenLoader';
import { Context } from '../../context/AppContext';
import { MODALS, ENABLE_USER_MANAGEMENT } from '../../constants';
import reviewSubmitted from '../../animations/tick.json';
import appendUTMParams from '../../utils/utmParams';

const StyledLink = styled(Link)`
  display: flex;
  i {
    height: 22px;
    position: relative;
    top: -4px;
  }
`;

const Form = loadable(() => import('./ReviewForm'), {
  fallback: <FullScreenLoader />,
});

const ReviewForm = ({ defaults = {} }) => {
  const modalName = MODALS.REVIEW_FORM;

  const {
    media: { mobile },
    auth,
    modal: { modals, hideModal },
    user: { userContactDetails },
  } = useContext(Context);

  const { data, show } = modals[modalName] || {};
  const [slideInShow, setSlideInShow] = useState(false);

  const { disableDefaults } = data || {};

  return (
    <DialogForm
      show={show}
      name={modalName}
      clickOutside
      onDialogFormClose={() => hideModal(modalName)}
      notificationSlider={{
        icon: (
          <Animation
            data={reviewSubmitted}
            height={mobile ? '150px' : '100px'}
            width={mobile ? '150px' : '100px'}
          />
        ),
        heading: 'Thanks for your review!',
        text: (
          <>
            <p>
              Keep an eye on your inbox over the next 1 to 2 business days to
              see when your review goes live.
            </p>
            {ENABLE_USER_MANAGEMENT && auth.token() && !mobile && (
              <StyledLink to="/reviews">
                Go to Review
                <Icon className="ls-icon icon-generalcaretrightsmall" />
              </StyledLink>
            )}
          </>
        ),
        button:
          ENABLE_USER_MANAGEMENT && auth.token() ? 'Go to Review' : 'Return',
        buttonProps: {
          onClick: () =>
            ENABLE_USER_MANAGEMENT && auth.token()
              ? window.open(appendUTMParams('/reviews'))
              : setSlideInShow(false),
          width: '161px',
        },
        show: slideInShow,
        onClose: () => setSlideInShow(false),
      }}
    >
      <Form
        data={{
          ...(disableDefaults ? {} : defaults),
          ...data,
          ...userContactDetails,
        }}
        slideInShow={slideInShow}
        setSlideInShow={setSlideInShow}
      />
    </DialogForm>
  );
};

export default ReviewForm;
